import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Topbar from "./Topbar";
import Footer from "./Footer";

const API_URL = process.env.REACT_APP_API_URL;

const estimateReadingTime = (html = "") => {
  const plain = html.replace(/<[^>]+>/g, " ").trim();
  const words = plain ? plain.split(/\s+/).length : 0;
  return Math.max(1, Math.round(words / 200));
};

export default function ProjectDetail() {
  const { name } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(
          `${API_URL}/api/projects/detail/${encodeURIComponent(name)}`
        );
        if (res.ok) setProject(await res.json());
      } catch (err) {
        console.error("Error fetching project:", err);
      } finally {
        setLoading(false);
      }
    })();
  }, [name]);

  return (
    <div className="detail-page">
      <Topbar />

      {loading ? (
        <div className="loader-wrap"><div className="loader" /></div>
      ) : !project ? (
        <div className="shell" style={{ padding: "6rem 0", textAlign: "center" }}>
          <p className="empty-state">Research project not found.</p>
          <Link to="/ViewProjects" className="btn-outline">Back to Research Projects</Link>
        </div>
      ) : (
        <>
          <div className="shell detail-top">
            <Link to="/ViewProjects" className="detail-back">All Research Projects</Link>
          </div>

          <header className="detail-hero">
            <div className="detail-hero-inner">
              <span className="detail-kicker">
                <span>Research Project</span>
                <span className="sep" />
                <span>
                  {new Date(project.date).toLocaleDateString("en-US", {
                    month: "long", day: "numeric", year: "numeric",
                  })}
                </span>
                <span className="sep" />
                <span>{estimateReadingTime(project.content)} min read</span>
              </span>
              <h1 className="detail-title">{project.name}</h1>
              {project.description && (
                <p className="detail-deck">{project.description}</p>
              )}
              <hr className="detail-rule" />
            </div>
          </header>

          <article
            className="detail-content"
            dangerouslySetInnerHTML={{ __html: project.content || "" }}
          />

          <div className="detail-close">
            <span className="detail-close-meta">End of case study</span>
            <Link to="/ViewProjects" className="link-arrow">More Research Projects</Link>
          </div>
        </>
      )}

      <Footer />
    </div>
  );
}
